module.exports = __webpack_public_path__ + "4e4efcd2a41b09847dd5242fd60f7692.svg";